import { create } from "zustand";

// Unsent ops another account left on this device, waiting for the signed-in user to decide.
export const useForeignOutbox = create<{ count: number | null }>(() => ({ count: null }));
